import CardModifier from './CardModifier';
import { addDragonbonesResources } from 'Utility/Resource/ResourceHelper';
import { CARD_MODIFIER_DRAGONBONES_PATH } from 'Constants/Dragonbones';
import DragonbonesComponent from 'Component/Dragonbones';
import { getLayout, GLayout } from 'Utility/layout/LayoutHelper';
import { ModifierTypeMap } from '../ModifierTypeMap';
import { ICardModifierData } from '../ICardModifierData';
import { TNTModifierLayout } from 'Layouts/Level/Cards/Modifiers/TNTModifierLayout';
import { CardModifierType } from "Prototype/Level/Card/CardModifierType";

export default class TNTModifier extends CardModifier {
    private _layout: GLayout<TNTModifierLayout>;
    onCreate(params: ICardModifierData): void {
        super.onCreate(params);
        // TODO: Getting the layout from the type map is pretty pointless if it still needs to be cast
        this._layout = getLayout(ModifierTypeMap[CardModifierType.tnt].layout);

        this.addChild(this._layout.root);


        // Reparent container into dragonbones animation
        const tntDragonBonesComponent = this._layout.tnt_modifier_armature.getComponent(DragonbonesComponent); 
        tntDragonBonesComponent.getSlotDisplay('tnt_card_image').addChild(this._layout.turn_count.container);

        this.container.interactiveChildren = false;
    }

    public getLayout() {
        return this._layout;
    }

    public static async preload(): Promise<void> {
        addDragonbonesResources("tnt_modifier", `${CARD_MODIFIER_DRAGONBONES_PATH}/TNT/`);
    }
}
